import Vue from 'vue';
import Project from 'src/api/project';
import $ from 'jquery';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { BfButton } from 'components/Butterfly';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { BfButton },
    data() {
        return {
            loadingData: false,
            numResponsesToUpdate: 0,
            isLoading: false
        };
    },
    computed: {
        ...mapGetters(['dataUnits', 'subscription', 'currentProject']),
        rowLimitExceeded() {
            return this.subscription?.projectRowLimit && this.currentProject?.data_units > this.subscription?.projectRowLimit;
        },
        dateModified() {
            return dayjs(this.currentProject.modified).format('DD-MMM-YYYY');
        },
        sufficientDataUnits() {
            if (this.numResponsesToUpdate < this.dataUnits) {
                return true;
            }
            else if (this.numResponsesToUpdate > this.dataUnits) {
                return false;
            }
            // Catchall, to be safe
            return false;
        }
    },
    mounted() {
        Project.getNewResponsesFromIntegration(this.currentProject.id)
            .then(response => {
            this.numResponsesToUpdate = response;
        });
    },
    methods: {
        number: FormatUtils.number,
        updateIntegration() {
            this.isLoading = true;
            Project.updateProjectFromIntegration(this.currentProject.id, {})
                .then((response) => {
                // Update our update button state
                Project.getNewResponsesFromIntegration(this.currentProject.id)
                    .then(response => {
                    this.numResponsesToUpdate = response;
                });
            })
                .finally(() => {
                this.isLoading = false;
                this.removeModal();
            });
        },
        popModal() {
            $('.ui.tiny.modal.update-modal').modal('show');
        },
        removeModal() {
            $('.ui.tiny.modal.update-modal').modal('hide');
        }
    }
});
